'use client';

import useCursorImageContainer from '@/client/stores/useCursorImageContainer';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import Link from 'next/link';
import React, { useEffect, useMemo } from 'react';

export interface ListCardItemProps {
  label: string;
  className?: ClassValue;
  link?: string;
  cover?: { id: string; width: number | null; height: number | null };
}

export const ListCardItem: React.FC<ListCardItemProps> = ({ label, link = '#', className, cover }) => {
  const value = useMemo(() => {
    if (cover) {
      return { src: `/api/asset/${cover.id}`, alt: `${label} cover image`, originWidth: cover.width ?? 200, originHeight: cover.height ?? 200 };
    } else {
      return null;
    }
  }, [cover, label]);

  const { setValue } = useCursorImageContainer();

  useEffect(() => setValue(null), [setValue]);

  return (
    <li
      className={cn('w-fit text-xs md:text-sm xl:text-lg hover:bg-black hover:text-white hover:dark:bg-white hover:dark:text-black duration-300', className)}
      onMouseEnter={() => setValue(value)}
      onMouseLeave={() => setValue(null)}
    >
      <Link href={link}>
        <span className={'sr-only'}>{label}</span>
        <span className={'aria-hidden'}>{`[ ${label} ]`}</span>
      </Link>
    </li>
  );
};
